import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import Stepper from "react-stepper-horizontal";
import SelectWorkOrders from "./SelectWorkOrders";
import UpdateSelectedWO from "./UpdateSelectedWO";
import WOPreview from "./WOPreview";
import Step4WOs from "./Step4WOs";
import * as RFSActionType from "../constants";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect } from "react-redux";

const steps = [
  { title: "Select work orders" },
  { title: "Update info" },
  { title: "Preview" },
  { title: "Confirm" },
];

class ReassignWO extends Component {
  static propTypes = {
    isDisplayReassignWOComponent: PropTypes.bool,
    data: PropTypes.array,
    dispatch: PropTypes.func,
    onRenderModal: PropTypes.func,
    ManagerStore: PropTypes.object,
    rfsRefNo: PropTypes.string,
  };
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      isShow: this.props.isDisplayReassignWOComponent,
      updatedWOs: [],
      displayModal: false,
      context: "",
      displayButton: false,
      title: "",
    };
  }

  
  toolTipBack() {
    return (
      <Tooltip className="in tooltip-siteone" id="disable-go-to">
        <span>Move to previous page</span>
      </Tooltip>
    );
  }

  toolTipClose() {
    return (
      <Tooltip className="in tooltip-siteone" id="disable-go-to">
        <span>close the modal</span>
      </Tooltip>
    );
  }

  toolTipNext() {
    return (
      <Tooltip className="in tooltip-siteone" id="disable-go-to">
        <span>Move to next page</span>
      </Tooltip>
    );
  }

  toolTipUpdate() {
    return (
      <Tooltip className="in tooltip-siteone" id="disable-go-to">
        <span>Update the Work orders</span>
      </Tooltip>
    );
  }

  toolTipDone() {
    return (
      <Tooltip className="in tooltip-siteone" id="disable-go-to">
        <span>Done Reassigning</span>
      </Tooltip>
    );
  }

  toolTipReassign() {
    return (
      <Tooltip className="in tooltip-siteone" id="disable-go-to">
        <span>Reassign the Work orders</span>
      </Tooltip>
    );
  }

  updateWOsValue = (activeStep) => {
    let defaultValuesForUpdate = this.props.ManagerStore.updatedValueForFilterWO;
    let filteredUsers = defaultValuesForUpdate.filter(item => item.value === '');    

    if(filteredUsers.length == 6 ){      
      this.setState({displayModal: true, context: 'Alert! All fields are empty, please select values for the form fields to continue with the WO updation.', displayButton: true, title: 'All Fields Empty !'})
    }
    else if(filteredUsers.length == 0 || filteredUsers.length == 1){
       this.setState({displayModal: false})
       this.updateWOs(activeStep)
    }
    else{     
      var fieldName = "";
      let assignTo = []
      for (let i = 0; i < filteredUsers.length; i++) {
        if(filteredUsers[i].fieldName == 'subcontractorProfile' || filteredUsers[i].fieldName == 'assignedUser' ){  
          assignTo.push(filteredUsers[i].fieldName)
          if(assignTo.length == 2){
            fieldName += 'Assign To';
          }
        }else if(filteredUsers[i].fieldName == 'workOrderType'){
          fieldName += 'Work Order Type';
        }else if(filteredUsers[i].fieldName == 'itemToRepair'){
          fieldName += 'Item to Repair';
        }else{
          fieldName += filteredUsers[i].fieldName;
        }
        
        if (i < filteredUsers.length - 1) {
          fieldName += ", ";
        }
      }
      this.setState({displayModal: true, context: <p>Are you sure you want to update the WO with empty value for <b style={{ textTransform: 'capitalize' }}>{fieldName}</b>?</p>, displayButton: false, title: 'Confirmation'})
    }
  };

  updateWOs = (activeStep) => {
    this.setState({ displayModal: false });
    let arr1 = this.props.ManagerStore.updatedValueForFilterWO;
    let arr2 = this.props.ManagerStore.filterWOs;
    console.log("arr1", arr1);
    console.log("arr2", arr2);
    // Create a mapping object from arr1 for quick lookups
    const arr1Mapping = arr1.reduce((map, item) => {
      map[item.fieldName] = {
        id: item.value,
        name: item.text,
      };
      return map;
    }, {});

    // Update arr2 with values from arr1Mapping
    const updatedArr2 = arr2.map((item) => {
      const newItem = {};
      for (const key in item) {
        if (arr1Mapping[key]) {
          newItem[key] = arr1Mapping[key];
        } else {
          newItem[key] = item[key];
        }
      }
      return newItem;
    });
    console.log("updatedArr2", updatedArr2, this.props.data);
    this.setState(
      {
        updatedWOs: updatedArr2,
        activeStep: activeStep + 1,
      },
      () => {
     const updatedValueForFilterWO = arr1.map(item =>  ({
          ...item,
          value: "",
          text: ""
      }));
        this.props.dispatch({
          type: RFSActionType.UPDATED_FILTER_VALUE_FOR_WO,
          payload:updatedValueForFilterWO,
        });
      }
    );
  };

  selectedWOFromStep1 = (activeStep) => {
    let defaultValuesForUpdate = 
      [
        {
          value: "",
          text: "",
          fieldName: "workOrderType",
        },
        {
          value: "",
          text: "",
          fieldName: "trade",
        },
        {
          value: "",
          text: "",
          fieldName: "subcontractorProfile",
        },
        {
          value: "",
          text: "",
          fieldName: "itemToRepair",
        },
        {
          value: "",
          text: "",
          fieldName: "problem",
        },
        {
          value: "",
          text: "",
          fieldName: "assignedUser",
        },
    ];
    if (this.props.ManagerStore.filterWOs.length === 0) {
      this.props.dispatch({
        type: RFSActionType.FILTER_WO,
        payload: this.props.data,
      });
    }
    this.props.dispatch({
      type: RFSActionType.UPDATED_FILTER_VALUE_FOR_WO,
      payload: defaultValuesForUpdate,
    });
    this.setState({ activeStep: activeStep + 1 });
  };
  getSectionComponent = () => {
    console.log("Step4WOs", this.props.ManagerStore.updatedWOs);
    switch (this.state.activeStep) {
      case 0:
        return <SelectWorkOrders data={this.props.data} />;
      case 1:
        return <UpdateSelectedWO />;
      case 2:
        return <WOPreview data={this.state.updatedWOs} />;
      case 3:
        return <Step4WOs data={this.props.ManagerStore.updatedWOs} />;
      default:
        return null;
    }
  };
  backfromCurrentStep = () =>{
    if (this.props.ManagerStore.filterWOs.length === 0) {
      this.props.dispatch({
        type: RFSActionType.FILTER_WO,
        payload: this.props.data,
      });
    }else{
      this.props.dispatch({
        type: RFSActionType.FILTER_WO,
        payload: this.props.ManagerStore.filterWOs,
      });
    }
    this.setState({
      activeStep: this.state.activeStep - 1,
    })
  }
  setUpdateWO = (activeStep) => {
    let { filterPreviewWO } = this.props.ManagerStore;
    let extractedData = [];
    if (filterPreviewWO.length === 0) {
      extractedData = this.state.updatedWOs.map((item) => ({
        workOrderTypeId: item.workOrderType && item.workOrderType.id,
        tradeId: item.trade && item.trade.id,
        itemToRepairId: item.itemToRepair && item.itemToRepair.id,
        problemId: item.problem && item.problem.id,
        status: item.statusValue,
        WONo: item.refNo.toString(),
        assignedUserId: item.assignedUser && item.assignedUser.id,
        subcontractorId:
          item.subcontractorProfile && item.subcontractorProfile.id,
        RoomId: null,
        AppointmentDate: null,
        LastClosedDate: null,
        LastResolvedDate: null,
      }));
    } else {
      extractedData = filterPreviewWO.map((item) => ({
        workOrderTypeId: item.workOrderType.id,
        tradeId: item.trade && item.trade.id,
        itemToRepairId: item.itemToRepair && item.itemToRepair.id,
        problemId: item.problem && item.problem.id,
        status: item.statusValue,
        WONo: item.refNo.toString(),
        assignedUserId: item.assignedUser && item.assignedUser.id,
        subcontractorId:
          item.subcontractorProfile && item.subcontractorProfile.id,
        RoomId: null,
        AppointmentDate: null,
        LastClosedDate: null,
        LastResolvedDate: null,
      }));
    }

    let params = {
      RefNos: [this.props.rfsRefNo],
      EditReassignMultipleWorkOrdersWithPropDto: extractedData,
    };
    this.props.dispatch({
      type: RFSActionType.UPDATE_WO_RASSIGN_VALUE,
      params,
      callback: () => {
        this.setState({ activeStep: activeStep + 1 });
      },
    });
  };
  render() {
    const { isDisplayReassignWOComponent } = this.props;
    const { activeStep } = this.state;
    return (
      <div>
        {this.state.displayModal ? (
          <Modal
            show={this.state.displayModal}
            id="confirm-modal"
            style={{ marginTop: "15%" }}
          >
            <Modal.Header>
              <Modal.Title id="contained-modal-title-lg">
                {this.state.title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>{this.state.context}</div>
            </Modal.Body>
            <Modal.Footer>
            <div className="suspend-group-btn" style={{ float: "left" }}>
            {this.state.displayButton? <button type="button" className="btn btn-primary btn-siteone" onClick={()=>this.setState({displayModal: false})}>
                ok
              </button> :  <div>
              <button type="button" className="btn btn-primary btn-siteone" onClick={()=> this.updateWOs(activeStep)}>
                Yes
              </button>
              <button
                type="button"
                className="btn btn-primary btn-siteone-default"
                data-dismiss="modal"
                onClick={()=>this.setState({displayModal: false})}
              >
                No
              </button>
                </div>
             }
            </div>
             
            </Modal.Footer>
          </Modal>
        ) : (
          " "
        )}

        <Modal
          show={isDisplayReassignWOComponent}
          dialogClassName="custom-modal"
          backdrop="static"
          keyboard={false}
          container={this}
          id="rename-modal"
          className="reassignWO-modal"
        >
          <Modal.Header className="reassign-modal-header">
            <Modal.Title style={{ fontWeight: "bold", fontSize: "18px" }}>
              Reassign Work Orders
              <button type='button' className='close' style={{ color: "black", fontSize: '30px' }} onClick={()=>this.props.onRenderModal(false)}>&times;</button>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>
              <Stepper steps={steps} activeStep={activeStep} />
              <div style={{ marginTop: "10px" }}>
                {this.getSectionComponent()}
                <Modal.Footer>
                  <ul className="wo-detail-bottom-btn">
                    {activeStep !== 0 &&
                      activeStep !== 3 &&
                      activeStep !== steps.length && (
                        <li className="wo-edit-li">
                          <OverlayTrigger
                            placement="top"
                            overlay={this.toolTipBack()}
                            delayHide={10}
                            delayShow={500}
                          >
                            <button
                              className="btn btn-primary btn-siteone-default btn-wo-edit"
                              onClick={() =>
                                this.backfromCurrentStep()
                              }
                            >
                              Back
                            </button>
                          </OverlayTrigger>
                        </li>
                      )}
                    {activeStep === 2 && (
                      //   <li className="wo-edit-li">
                      <OverlayTrigger
                        placement="top"
                        overlay={this.toolTipUpdate()}
                        delayHide={10}
                        delayShow={500}
                      >
                        <button
                          className="btn btn-primary btn-siteone"
                          onClick={() => {
                            if (activeStep === 0) {
                              this.setState({ activeStep: activeStep + 1 });
                            } else if (activeStep === 2) {
                              this.setUpdateWO(activeStep);
                            }
                          }}
                        >
                          Update
                        </button>
                      </OverlayTrigger>

                      //   </li>
                    )}

                    {activeStep === 3 && activeStep === steps.length - 1 && (
                      <li className="wo-edit-li">
                        <OverlayTrigger
                          placement="top"
                          overlay={this.toolTipReassign()}
                          delayHide={10}
                          delayShow={500}
                        >
                          <button
                            className="btn btn-primary btn-siteone-default btn-wo-edit"
                            onClick={() => {
                              this.setState({
                                activeStep: 0,
                              });
                            }}
                          >
                            Reassign
                          </button>
                        </OverlayTrigger>
                      </li>
                    )}

                    {activeStep === 3 && activeStep === steps.length - 1 && (
                      <OverlayTrigger
                        placement="top"
                        overlay={this.toolTipDone()}
                        delayHide={10}
                        delayShow={500}
                      >
                        <button
                          className="btn btn-primary btn-siteone"
                          onClick={() => {
                            this.props.onRenderModal(false);
                          }}
                        >
                          Done
                        </button>
                      </OverlayTrigger>
                    )}

                    {activeStep === 0 && (
                      <li className="wo-edit-li">
                        <OverlayTrigger
                          placement="top"
                          overlay={this.toolTipClose()}
                          delayHide={10}
                          delayShow={500}
                        >
                          <button
                            className="btn btn-primary btn-siteone-default btn-wo-edit"
                            onClick={() => {
                              this.props.onRenderModal(false);
                            }}
                          >
                            Close
                          </button>
                        </OverlayTrigger>
                      </li>
                    )}

                    {activeStep !== steps.length - 1 && activeStep !== 2 && (
                      //   <li className="wo-edit-li">
                      <OverlayTrigger
                        placement="top"
                        overlay={this.toolTipNext()}
                        delayHide={10}
                        delayShow={500}
                      >
                        <button
                          className="btn btn-primary btn-siteone"
                          onClick={() => {
                            if (activeStep === 0) {
                              this.selectedWOFromStep1(activeStep);
                            } else {
                              this.updateWOsValue(activeStep);
                            }
                          }}
                        >
                          Next
                        </button>
                      </OverlayTrigger>
                      //   </li>
                    )}
                  </ul>
                </Modal.Footer>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    ManagerStore: state.RFSStore,
  };
};

export default connect(mapStateToProps)(ReassignWO);



// WEBPACK FOOTER //
// ./src/Request-Services/Components/ReassignWO.js